import React, { Component } from "react"
import { Input, Button, Affix, message } from "antd"
import { observer, inject } from "mobx-react"
import MaterialModal from "app/components/normal/MaterialModal"
import closeIcon from "app/styles/images/sp/close.svg"
import styled from 'styled-components'
import { action } from "mobx"
import MaterialForm from "app/components/normal/MaterialForm/MaterialForm"
import MaterialFormItem from "app/components/normal/MaterialFormItem/MaterialFormItem"

const InputGroup = Input.Group

const CreateOrgBtn = styled.button`
  width: 127px;
  height: 40px;
  background: #286CAC;
  color: white;
  font-size: 14px;
  border-radius: 3px;
  cursor: pointer;
  outline: none;
  border: none;
`

@inject("auth", "store") @observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dayKey: "-1",
      createModalShowed: false
    }
  }
  componentDidMount() {
    this.props.auth.getApps()
  }

  @action
  changeSearch = (e) => {
    if (this.timer) {
      clearTimeout(this.timer)
    }
    const {
      list: { filterData }
    } = this.props.store
    const keywords = e.target.value

    this.timer = setTimeout(() => {
      this.timer = null
      this.setState({
        inputSearch: keywords,
      })
      filterData({ keywords })
    }, 300)
  }

  closeModal = (modal) => {
    this.setState({
      [modal]: false
    })
  }

  showCreateOrgModal = () => {
    this.setState({
      createModalShowed: true
    })
  }

  render() {
    const { createModalShowed } = this.state
    return (
      <Affix
        className="affix-head"
        target={() => document.getElementsByClassName("salt-pagelayout")[0]} offsetTop={50}
      >
        <div className="affix-back">
          <div className="statistics-search-bar">
            <div className="search-input">
              <InputGroup className="ant-search-input">
                <Input
                  placeholder="输入机构名称搜索"
                  size="default"
                  onChange={this.changeSearch}
                />
                <div className="ant-input-group-wrap">
                  <Button icon="search" className="ant-search-btn" size="default" />
                </div>
              </InputGroup>
            </div>
            <CreateOrgBtn
              className="create-account-btn"
              onClick={() => this.showCreateOrgModal()}
            >
              + 创建机构
            </CreateOrgBtn>
          </div>

          {createModalShowed && (
            <CreateOrgModal
              store={this.props.store}
              onClose={() => this.setState({ createModalShowed: false })}
              apps={this.props.auth.apps}
            />)
          }
        </div>
      </Affix>
    )
  }
}

@observer
class CreateOrgModal extends Component {
  confirmCreate = () => {
    const { onClose } = this.props
    const { store: { list, createOrg } } = this.props
    createOrg()
      .then(res => {
        message.success('机构创建成功')
        list.getTableData()
          .then(
            res => {
              onClose()
              list.updateTableData(res)
              list.initPageIndex()
            }
          )

      }, err => {
        message.error(err)
      })
  }

  render() {
    const { onClose } = this.props
    const { submitData, updateField } = this.props.store
    return (
      <MaterialModal
        title="创建机构"
        width={450}
        className="preview-account-create-modal"
        buttonText="确认添加"
        visible
        action={() => this.confirmCreate()}
      >
        <img
          className="pgx-modal-close"
          src={closeIcon}
          alt="关闭对话框"
          onClick={onClose}
        />
        <MaterialForm>
          <MaterialFormItem
            labelText="机构名"
            labelWidth={60}
          >
            <Input
              className="createAccount-input"
              placeholder="请输入机构名"
              value={submitData.name}
              onChange={(evt) => updateField(evt, "name")}
            />
          </MaterialFormItem>
          <MaterialFormItem
            labelWidth={60}
            labelText="联系电话"
            justify="center"
          >
            <Input
              name="tel"
              className="createAccount-input"
              placeholder="请输入联系电话"
              value={submitData.tel}
              onChange={(evt) => updateField(evt, "tel")}
            />
          </MaterialFormItem>
          <MaterialFormItem
            labelWidth={60}
            labelText="地址"
            justify="center"
          >
            <Input
              name="address"
              className="createAccount-input"
              placeholder="请输入地址"
              value={submitData.address}
              onChange={(evt) => updateField(evt, "address")}
            />
          </MaterialFormItem>
          <MaterialFormItem
            labelWidth={60}
            labelText="打印地址"
            justify="center"
          >
            <Input
              name="printAddress"
              className="createAccount-input"
              value={submitData.printAddress}
              placeholder="请输入打印地址"
              onChange={(evt => updateField(evt, "printAddress"))}
            />
          </MaterialFormItem>
          <MaterialFormItem
            labelWidth={60}
            labelText="派驻代表"
            justify="center"
          >
            <Input
              name="deputy"
              value={submitData.deputy}
              className="createAccount-input"
              placeholder="请输入派驻代表"
              onChange={(evt) => updateField(evt, "deputy")}
            />
          </MaterialFormItem>
          <MaterialFormItem
            labelWidth={60}
            labelText="技术支持"
            justify="center"
          >
            <Input
              name="support"
              value={submitData.support}
              className="createAccount-input"
              placeholder="请输入技术支持"
              onChange={(evt) => updateField(evt, "support")}
            />
          </MaterialFormItem>
        </MaterialForm>
      </MaterialModal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/preview/organization/containers/DataHeader.js